import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-state-normal-s",
  "use": "app-icon-state-normal-s-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-state-normal-s\"><g fill=\"#7ADFA0\" fill-rule=\"evenodd\"><rect width=\"16\" height=\"16\" rx=\"8\" /><rect stroke=\"#FFF\" stroke-width=\"2\" x=\"5\" y=\"5\" width=\"6\" height=\"6\" rx=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol